import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import { VerifierStaffPageVerifierAdmin } from 'src/pages/verifierStaff';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    accessRoles: [BusinessRole.VerifierAdmin],
    element: <VerifierStaffPageVerifierAdmin />,
  },
];

export const VERIFIER_STAFF_ROUTE: RouteProps = {
  path: appRoutes.verifierStaff.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasVerifierRoles],
};
